import { Entity } from "../../Entity";
import ChargeTemplateFactory from "../../Factories/ChargeTemplateFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { ChargeTemplateInterface } from "./ChargeTemplateInterface";
import { CurrencyInterface } from "../../../Currency/CurrencyInterface";
import { PeriodInterface } from "./Period/PeriodInterface";
import { ChargeClassInterface } from "./ChargeClass/ChargeClassInterface";
import { PaymentOffsetInterface } from "./PaymentOffset/PaymentOffsetInterface";
import { TypeInterface } from "./Type/TypeInterface";
import { ContractInterface } from "../Contract/ContractInterface";
import { UnitInterface } from "../Unit/UnitInterface";
import { PropertyInterface } from "../Property/PropertyInterface";
import { CompanyInterface } from "../Company/CompanyInterface";
import { PersonInterface } from "../Person/PersonInterface";
import Store from "../../../Store/Store";
import ChargeClassContainer from "./ChargeClass/ChargeClassContainer";

class ChargeTemplate extends Entity implements ChargeTemplateInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return ChargeTemplateFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get amount(): number {
    return this.data.amount;
  }

  get currency(): CurrencyInterface {
    return this.data.currency;
  }

  get repeatPeriod(): PeriodInterface {
    return this.data.repeatPeriod;
  }

  get chargeClass(): ChargeClassInterface {
    return this.data.chargeClass;
  }

  get description(): string {
    return this.data.description;
  }

  get contractId(): number | null {
    return this.data.contractId;
  }

  get contract(): ContractInterface {
    return this.relation("app.contracts", this.data.contractId)[0];
  }

  get unitId(): number | null {
    return this.data.unitId;
  }

  get unit(): UnitInterface {
    return this.newRelation("units.byId", this.data.unitId)[0];
  }

  get propertyId(): number | null {
    return this.data.propertyId;
  }

  get property(): PropertyInterface {
    return this.newRelation("properties.byId", this.data.propertyId)[0];
  }

  get paymentOffset(): PaymentOffsetInterface {
    return this.data.paymentOffset;
  }

  get type(): TypeInterface {
    return this.data.type;
  }

  get dueDateFirstPayment(): Date {
    return this.data.dueDateFirstPayment;
  }

  get firstDate(): Date {
    return this.data.firstDate;
  }

  get isDefault(): boolean {
    return this.data.isDefault;
  }

  get endDate(): Date {
    return this.data.endDate;
  }

  get removed(): boolean {
    return this.data.removed;
  }

  get creationDate(): Date {
    return this.data.creationDate;
  }

  get isPaidDirectlyToOwner(): boolean {
    return this.data.isPaidDirectlyToOwner;
  }

  get companyId(): number {
    return this.data.companyId;
  }

  get company(): CompanyInterface {
    return [...Store.getConfigurator().getState().app.companies]
            .find(company => company.id === this.companyId);
  }

  get contactId(): number {
    return this.data.contactId;
  }

  get contact(): PersonInterface {
    return this.relation("app.persons", this.data.contactId)[0];
  }

  get isCollective(): boolean {
    return this.data.isCollective;
  }

  get counterparty(): CompanyInterface | PersonInterface {
    if (!!this.contact) {
      return this.contact;
    }

    if (!!this.company) {
      return this.company;
    }
  }

  get isReceivable(): boolean {
    return this.chargeClass?.id === ChargeClassContainer.pickIdFromLabel("Receivable");
  }

  get isPayable(): boolean {
    return this.chargeClass?.id === ChargeClassContainer.pickIdFromLabel("Payable");
  }
}

export { ChargeTemplate };
